(function(){
  "use strict";
  angular
  .module('swif.interventions')
  .component('searchGonet', {
      templateUrl: 'partials/openstc/search_gonet_component.html',
      controller: SearchGonetController,
      bindings: {
          search: "=",
          searchType: "@"
      }
  });

  function SearchGonetController($scope, $window, openstc, swif,goNetEndpointApi){
    'ngInject';
    console.log('Init SearchGonetController')

    var $ctrl = this;
    $scope.model = $ctrl.search
    $scope.model.showRequesterButtons = ($ctrl.searchType === 'requester')
    $scope.model.showSiteButtons = ($ctrl.searchType === 'site')
    // Setting by what we want to search, 7: search by owners, address or parcel matricule, 5: search by address or parcel matricule
    // 7 is only needing for partner search (requester organization part)
    var searchBy = $ctrl.searchType === 'requester' ? '7' : '5'
    var modelSearch = $ctrl.searchType === 'requester' ? 'partner' : 'site'
    $ctrl.onMunicipalityChange = onMunicipalityChange;
    $ctrl.selectItemOnClick = selectItemOnClick;

    $scope.$watch('model.inputSearch', watchInputSearch);
    $scope.filters = openstc.request.getFilters($scope.model);
    $ctrl.token = $window.localStorage.getItem('token')// To display some buttons only for some cases
    this.onInit = function () {
      let filter = {}
      swif.data.get('canadian_municipalities', undefined, filter).then(function (data) {
          if(data.length === 1){
              $scope.model.municipality = [data[0].id, data[0].name]
              $scope.model.codemuni = data[0].codemuni
          }
      })
      if($scope.model.partner_id){
        let filter = {}
        swif.data.addFilter(filter, 'name', '=', $scope.model.partner_id[1])
        swif.data.get('partner', undefined, filter).then(function (data) {
          if($scope.model.partner_id){
            let filter = {fields: ['name','parcel_matricule']}
            swif.data.addFilter(filter, 'name', '=', $scope.model.partner_id[1])
            swif.data.get('site', undefined, filter).then(function (data) {
              if(data.length === 0){
                $scope.model.inputSearch = $scope.model.partner_id[1]
              }
            })
          }
        })
      }
    }
    this.onInit()

    function onMunicipalityChange(municipality) {
      // Get Canadian municipality update
      $scope.model.codemuni = municipality.codemuni
      $scope.layer_id = municipality.layer_id;
      $scope.map_city_name = municipality.map_city_name;
    }

    $ctrl.onIsTenantChange = function (value) {
      $scope.model.is_tenant = value
      if ($scope.model.is_tenant) {
        searchBy = '5'
      }
      $scope.addPartnerAddressData = !!($scope.model.is_tenant && $scope.model.partner_id);
    }

    $ctrl.onIsOwnerChange = function (value) {
      $scope.model.is_owner = value
      if($scope.model.is_owner){
      searchBy = '7'
        if($scope.model.partner_id){
        $scope.addPartnerAddressData = true;
        }
      }
    }

      function watchInputSearch(newV){
        $scope.items = []
        if(newV){
            let token = $window.localStorage.getItem('token');
            // call GoNet API to get users not already in OpenSTC
            goNetEndpointApi.getGoNetAutoComplete(token, newV, searchBy, $scope.model.codemuni)
                .success(function(resp){
                  $scope.items = resp;
                  if (resp.length === 1) {
                    selectItemOnClick(resp[0])
                  }
                })
                .error(function(data, status, header, config){
                    console.log("data", data, "status", status, "header", header, "config", config)
                    if (status === 401) {
                        alert('Connection error, please reload the modal')
                    }
                })
        } else {
            $scope.addPartnerData = false;
            $scope.addPartnerAddressData = false;
            $scope.addSiteData = false;
        }
      }

      function selectItemOnClick (item) {
          // Choosing the user from the autocomplete list
          let token = $window.localStorage.getItem('token');
          // call GoNet API to get user details
          goNetEndpointApi.getGoNetRoleInfo(token, item.mat18, $scope.model.codemuni)
            .success(resp => {
              resp[0].proprietairesNb = resp[0].proprietaires.length;
              if(resp.length > 1){
                _.forEach(resp, function (value) {
                  value.proprietaires = value.proprietaires.join(', ');
                })
              }else {
                resp[0].proprietaires = resp[0].proprietaires.join(', ');
              }
              $scope.model.selected_item = resp[0];
              getExistingItem(resp[0],token, modelSearch)
              $scope.items = resp
              if(!$scope.model.goNetSearch) {
                  $scope.model.name = item.adresse;
                  $scope.model.parcel_matricule = item.mat18;
                  $scope.model.cadastral_parcel = item.lot
                  $scope.model.owners = resp[0].proprietaires;
                  $scope.addPartnerData = false
                  $scope.addPartnerAddressData = false;
                  $scope.addSiteData = false
              }
            })
            .error(function(data, status, header, config){
                console.log("data", data, "status", status, "header", header, "config", config)
            })
      }


      function getExistingItem(item,token, modelSearch){
          // checking if organization already exists
        let filter = {}
        swif.data.addFilter(filter, 'name', '=', item.adresse);
        swif.data.addFilter(filter, 'parcel_matricule', '=', item.mat18);
        swif.data.searchRead(modelSearch, filter).then(function (data) {
          if(modelSearch === 'partner'){
            $scope.addPartnerData = true;
            $scope.addPartnerAddressData = false;
            if (data.ids.length > 0) {
              // If partner already exists, get partner  data and checking if partner address already exists
              $scope.addPartnerData = false;
              $scope.addPartnerAddressData = true;
              $scope.model.partner_id = [data.records[0].id, data.records[0].name]
              checkExistingPartnerAddress(item)
            }
          } else {
            $scope.addSiteData = true;
            // Getting all the needed data for created new site from GoNet
            goNetEndpointApi.getGoNetAutoComplete(token, item.mat18,searchBy, $scope.model.codemuni).success(resp=> {
              goNetEndpointApi.getGoNetRoleInfo(token, resp[0].mat18, $scope.model.codemuni).success(result => {
                result[0].proprietaires = result[0].proprietaires.join(', ')
                $scope.items = result
              })
            })
            if (data.ids.length > 0) {
              $scope.model.inputSearch = ""
              $scope.addSiteData = false;
              $scope.model.site1 = [data.records[0].id, data.records[0].name]
            }
          }
        })
      }

      $ctrl.updateItemInformation = function (){
          let filter = {fields: ['id', 'name']}
          swif.data.addFilter(filter, 'name', '=', $scope.model.selected_item.adresse);
          swif.data.addFilter(filter, 'parcel_matricule', '=', $scope.model.selected_item.mat18);
          swif.data.get(modelSearch, undefined, filter).then(function (data) {
            if(modelSearch === 'partner'){
              $scope.model.partner_id = [data[0].id, data[0].name]
            }else {
              $scope.model.site1 = [data[0].id, data[0].name]
            }
          })
        }

      $ctrl.addItem = function (itemModel) {
        let item = $scope.model.selected_item;
        itemModel.model.is_canadian = true;
        itemModel.model.name = item.adresse;
        itemModel.model.parcel_matricule = item.mat18;
        itemModel.model.cadastral_parcel = item.lot
        itemModel.model.owners = item.proprietaires;
        if(modelSearch === 'partner'){
          $scope.addPartnerData = false
          $scope.addPartnerAddressData = true;
        }else {
          itemModel.model.street = item.adresse;
          itemModel.model.city = $scope.model.municipality[1]
          $scope.addSiteData = false
        }
      }

      function checkExistingPartnerAddress(user){
        let filter = {}
        if($scope.model.is_owner){
          swif.data.addFilter(filter, 'name', '=', user.proprietaires);
          swif.data.get('partner_address', undefined, filter).then(function (contact) {
            $scope.addPartnerAddressData = true;
            if (contact.length > 0)  {
                getPartnerContactData(contact[0].partner_id[0]);
                $scope.addPartnerAddressData = false;
            }
          })
        } else {
          $scope.addPartnerAddressData = true
        }
    }

    $ctrl.addPartnerAddress = function (partner_address) {
      let user = $scope.model.selected_item;
      partner_address.model.is_canadian = true
      partner_address.model.city = $scope.model.municipality[1];  // city name
      partner_address.model.partner_id = $scope.model.partner_id;
      if (user) {
        partner_address.model.street = user.adresse;
        if ($scope.model.is_tenant) {
          partner_address.model.name = ''
          partner_address.model.function = "Locataire"
        } else {
          if (user.proprietairesNb > 1) {
            partner_address.model.name = '';
            partner_address.model.function = "Propriétaire"
          } else if (user.proprietairesNb === 1) {
            partner_address.model.name = user.proprietaires
            partner_address.model.function = "Propriétaire"
          }
        }
      }
    }

    $ctrl.updateRequesterInformation = function () {
      getPartnerContactData($scope.model.partner_id[0])
    }

    function getPartnerAddressData(data) {
      //get partner address data from database
      let newFilter = {}
      swif.data.addFilter(newFilter, 'partner_id', '=', data.id);
      swif.data.get("partner_address", undefined, newFilter).then(function (contactData) {
        $scope.model.partner_address = [contactData[0].id, contactData[0].name]
        $scope.model.partner_id = contactData[0].partner_id;
        $scope.model.inputSearch = "";
        $scope.model.partner = data
        $scope.model.partner.owners = data.owners
      })
    }

    function getPartnerContactData(partner_id) {
      // get partner Data from database
      let filter = {}
      // list all the wanted partner's fields
      filter.fields = ['id', 'name', 'cadastral_parcel', 'parcel_matricule', 'owners', 'technical_service_id', 'technical_site_id'];
      swif.data.get('partner', partner_id, filter).then(function (data) {
        $scope.currentPartner = data;
        if (data.technical_service_id && !$scope.model.service_id) {
          $scope.model.service_id = data.technical_service_id;
        }
        if (data.technical_site_id && !$scope.model.site1) {
          $scope.model.site1 = data.technical_site_id;
        }
        // getting partner address's information
        getPartnerAddressData(data)
      })
    }
  }
})();


